import React from "react";
import PropTypes from "prop-types";

import { formatDate } from "utils";

import Popper from "components/Popper";

import { MeetingCard } from "../MeetingCard";

function RecentMeeting({ title, meeting, onEdit, onDelete, ...props }) {
  const dateTimeFormatter = formatDate("simpleDateTime");

  if (!meeting) {
    return (
      <div style={{ display: "flex", gap: "0.5em", alignItems: "center" }}>
        <span style={{ height: "20px" }}>{title}</span>

        <span
          style={{ fontWeight: "normal", height: "20px", color: "grey" }}
          {...props}
        >
          None
        </span>
      </div>
    );
  }

  return (
    <Popper
      on="hover"
      position="right center"
      wide
      hoverable
      style={{ padding: "0" }}
      data-test="recent-meeting-popup"
      trigger={
        <div style={{ display: "flex", gap: "0.5em", alignItems: "center" }}>
          <span style={{ height: "20px" }}>{title}</span>

          <span style={{ fontWeight: "normal", height: "20px" }} {...props}>
            {dateTimeFormatter(meeting.startDate)}
          </span>
        </div>
      }
    >
      <MeetingCard meeting={meeting} onEdit={onEdit} onDelete={onDelete} />
    </Popper>
  );
}

RecentMeeting.propTypes = {
  title: PropTypes.string.isRequired,
  meeting: PropTypes.shape({ startDate: PropTypes.instanceOf(Date) }),
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

RecentMeeting.defaultProps = {
  meeting: null,
  onEdit: () => {},
  onDelete: () => {},
};

export default RecentMeeting;
